<template>
  <div
    class="maintenance-wrapper"
    :class="className"
  >
    <div/>

    <div
      class="text-center maintenance-message"
      v-html="notification.message"
    />

    <a
      href="Javascript:"
      title="Melding sluiten"
      class="notification-close"
      @click="markAsRead"
    >
      <i class="fas fa-times"/>
    </a>
  </div>
</template>

<script lang="ts">
import EventBus from '@/misc/event-bus'
import type { CustomWindow } from '@/misc/custom-window'
import { HttpPost } from '@/services/Service'

declare let window: CustomWindow

export default {
  name: 'MaintenanceNotification',

  props: {
    userId: {
      type: Number,
      required: true
    },

    message: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: 'informative'
    },

    uuid: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      notification: {
        message: this.message,
        type: this.type,
        uuid: this.uuid
      }
    }
  },

  computed: {
    className () {
      return `notification-${this.notification.type}`
    }
  },

  mounted () {
    this.startListening()
  },

  methods: {
    startListening () {
      window.Echo?.private(`App.Models.User.${this.userId}`)
        .notification((notification) => {
          if (notification.type === 'App\\Notifications\\MaintenanceNotificationResolved') {
            this.removeNotification()
          }

          if (notification.type === 'App\\Notifications\\MaintenanceNotification') {
            this.addNotification(notification)
          }
        })
    },

    setCssVariable (value) {
      document.getElementsByTagName('body')[0].style.setProperty('--maintenance-notification-height', value)
    },

    removeNotification () {
      this.notification.message = null
      this.notification.uuid = null
      this.notification.type = null

      this.setCssVariable('0px')
      EventBus.$emit?.('maintenance-notification-hidden')
    },

    addNotification (notification) {
      this.notification.message = notification.message
      this.notification.uuid = notification.uuid
      this.notification.type = notification.type_class

      this.setCssVariable('35px')
      EventBus.$emit?.('maintenance-notification-shown')
    },

    async markAsRead () {
      return await HttpPost('/maintenance-notification/read', { uuid: this.notification.uuid })
        .then(() => {
          this.setCssVariable('0px')

          EventBus.$emit?.('maintenance-notification-hidden')
        })
        .catch(console.error)
    }
  }
}
</script>

<style scoped lang="scss">
div.maintenance-wrapper {
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--maintenance-notification-height);
  max-height: var(--maintenance-notification-height);
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  transition: height ease-in-out 200ms;
}
</style>
